import { render, staticRenderFns } from "./VenueSeats.vue?vue&type=template&id=569facce&scoped=true&"
import script from "./VenueSeats.vue?vue&type=script&lang=js&"
export * from "./VenueSeats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569facce",
  null
  
)

export default component.exports